import { yupResolver } from "@hookform/resolvers/yup";
import PillButton from "components/button/Pills";
import Input from "components/Input";
import { showToast } from "components/Toaster";
import { FormProvider, useForm } from "react-hook-form";
import React from "react";
import httpClient from "services/network/httpClient";
import * as yup from "yup";

const schema = yup.object().shape({
  productCode: yup.string().trim().required("Product Code Is Required"),
  productName: yup
    .string()
    .trim()
    .matches(/^[a-zA-Z0-9 .-]+$/, "Product Name can only contain letters, numbers, and spaces")
    .required("Product Name is Required"),
});

export interface ProductProps {
  productId: string;
  productName: string;
}

interface EditProps {
  updatedData: any;
  onClose: () => void;
  getData: () => void;
}

const EditProducts = ({ updatedData, onClose, getData }: EditProps) => {
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: { ...updatedData },
  });

  const handleProductNameChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const value = e.target.value;
    const sanitizedValue = value.replace(/[^a-zA-Z0-9 .-]/g, '');

    // Set the input field value and update React Hook Form
    if (value !== sanitizedValue) {
      e.target.value = sanitizedValue;
      // Manually trigger React Hook Form field change
      methods.setValue("productName", sanitizedValue, { shouldValidate: true });
    }
  };

  const submit = (data: ProductProps) => {
    // Final validation before submission
    const specialCharsRegex = /[^a-zA-Z0-9 .-]/g;
    if (specialCharsRegex.test(data.productName)) {
      showToast("Product Name cannot contain special characters", "error");
      return;
    }
    httpClient
      .put(`product/update`, data)
      .then((response: any) => {
        if (response.success === true) {
          showToast("Product details Edited Successfully", "success");
        } else {
          showToast(`${response.error.message}`, "error");
        }
      })
      .catch((error: any) => {
        console.log(error);
        showToast("something went wrong", "error");
      })
      .finally(() => {
        onClose();
        getData();
      });
  };
  return (
    <FormProvider {...methods}>
      <form
        onSubmit={methods.handleSubmit(submit)}
        className="m-10 flex flex-col gap-5"
      >
        <Input
          name={"productCode"}
          label={"Product Code"}
          placeholder="Enter Product Code"
          required={true}
        ></Input>
        <Input
          name={"productName"}
          label={"Product Name"}
          placeholder="Enter Product Name"
          required={true}
          onChange={handleProductNameChange}
          onKeyDown={(e) => {
            // Prevent typing of special characters
            const specialChars = /[^a-zA-Z0-9 .-]/g;
            if (specialChars.test(e.key) && e.key.length === 1) {
              e.preventDefault();
            }
          }}
        ></Input>
        <div className="flex gap-10 m-5 items-center justify-end ml-20">
          <PillButton type="submit" className="flex-1" variant="secondary">
            {" "}
            Submit{" "}
          </PillButton>
          <PillButton type="reset" onClick={onClose} variant="primary">
            {" "}
            Cancel{" "}
          </PillButton>
        </div>
      </form>
    </FormProvider>
  );
};
export default EditProducts;
